import axios from "axios";

export default {
  namespaced: true,
  state: {
    departments: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    departmentsMessage: ''
  },
  mutations: {
    RECEIVED_DEPARTMENTS(state, payload) {
      state.departments = payload;
      state.isReceiving = false;
    },
    RECEIVING_DEPARTMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_DEPARTMENT(state, payload) {
      state = Object.assign(state, {
        departments: [...state.departments, payload],
        isReceiving: false,
      })
    },
    RECEIVING_DEPARTMENT(state) {
      state.isReceiving = true;
    },
    UPDATED_DEPARTMENT(state, payload) {
      let index = state.departments.findIndex(department => department._id === payload._id);
      state = Object.assign(state, {
        departments: state.departments.map((department, i) => {
          if (i === index) {
            return Object.assign({}, department, payload);
          }
          return department;
        }),
        isUpdating: false,
        departmentsMessage: 'Departments has been updating!',
      })
    },
    UPDATING_DEPARTMENT(state) {
      state.isUpdating = true;
    },
    DELETED_DEPARTMENT(state, payload) {
      let indexToDelete = state.departments.findIndex(department => department._id === payload._id);
      let departments = [...state.departments];
      departments.splice(indexToDelete, 1);
      state = Object.assign(state, {
        departments: [...departments],
        isDeleting: false,
        idToDelete: null,
        departmentsMessage: 'Department has been Deleted!',
      });
    },
    DELETING_DEPARTMENT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getDepartmentsRequest({dispatch}) {
      dispatch("receivingDepartments");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/departments';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveDepartments", res.data);
      })
    },
    updateDepartmentRequest({dispatch}, payload) {
      dispatch("updatingDepartment");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/department/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateDepartment", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateDepartmentImageRequest({dispatch}, payload) {
      dispatch("updatingDepartment");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/department/image/' + id;
      let data = new FormData();
      data.append('image', payload.departmentimage, payload.imagename); 
      delete payload['departmentimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateDepartment", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createDepartmentRequest({dispatch}, payload) {
      dispatch("receivingDepartments");
      let url;
      let data;
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      if(payload.departmentimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/department/withimage';
        data = new FormData();
        data.append('image', payload.departmentimage, payload.imagename); 
        delete payload['departmentimage'];
        for (let x in payload) {data.append(x, payload[x]);}
      } else {
        url = 'https://api.tradexc.com:3000/insert/department';
        data = payload;
      }
      axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveDepartment", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteDepartmentRequest({dispatch}, payload) {
      dispatch("deletingDepartment", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/department/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteDepartment", {_id: payload._id});
      })
    },
    receiveDepartments({commit}, payload) {
      commit("RECEIVED_DEPARTMENTS", payload)
    },
    receivingDepartments({commit}) {
      commit("RECEIVING_DEPARTMENTS")
    },
    receiveDepartment({commit}, payload) {
      commit("RECEIVED_DEPARTMENT", payload)
    },
    receivingDepartment({commit}) {
      commit("RECEIVING_DEPARTMENT")
    },
    updateDepartment({commit}, payload) {
      commit("UPDATED_DEPARTMENT", payload)
    },
    updatingDepartment({commit}) {
      commit("UPDATING_DEPARTMENT")
    },
    deleteDepartment({commit}, payload) {
      commit("DELETED_DEPARTMENT", payload)
    },
    deletingDepartment({commit}, payload) {
      commit("DELETING_DEPARTMENT", payload)
    }
  },
};
